import React, { useState, useEffect, useContext } from 'react';
import {format} from "date-fns";

import * as fkn from "../../../lib/fkn";
import * as net from "../../../lib/net";
import * as utils from "../../../assets/utils";
import {toTid} from "../../../assets/utils";

import Dt_Cal from "../../../lib/ui/dt_cal";

import Dd_Sel from "../../../lib/ui/dd_sel";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Kort_Per extends React.Component {
  constructor(props, context) {
    super(props);

    this.dt_fd = React.createRef();
    this.dt_td = React.createRef();
    this.dt_bdt = React.createRef();

    this.store = props.store;
    this.pms = props.store.pms;

    this.state = {};
    this.state.fkn = "";
    this.state.sortid = "";
    this.state.konto = "";
    this.state.dta = [];
    this.state.kta = [];
    this.state.tot = {};

      this.state.today = new Date();
    var dts = format(this.state.today, "yyyy-MM-dd");
    this.state.fdat = dts;
    this.state.tdat = dts;
    if(this.pms.base) {
      //this.state.fdat = this.pms.base.fdat;
      //this.state.tdat = this.pms.base.tdat;
  }
  if(props.wnds) {
    if(props.wnds.fdat) this.state.fdat = props.wnds.fdat;
    if(props.wnds.tdat) this.state.tdat = props.wnds.tdat;
  }
  //this.state.fdat = "2023-01-01";
  //this.state.tdat = "2023-01-31";

    var bdts = format(this.state.today, "yyyy-01-01");
      this.state.bdat = bdts;

      this.state.msg = {};
      this.state.wnds = {};
      this.selitems = [
        { fkn: 'upd', text: 'Uppdatera' }
      ];
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    //if(this.props.wnds.show) this.krub_rvs();
    //this.konto_per();
  }

  dlg_style() {
    var css = {};
    //css.width = window.innerWidth * 0.8;
    //css.height = window.innerHeight * 0.8;
    return css;
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = (window.innerHeight * 0.9) - 180;
      css.overflow = "auto";
      return css;
  }
  th_style(id) {
      var css = {};
      css.cursor = "pointer";
      if(id == this.state.sortid) css.color = "#080";
      return css;
  }
    row_style(row) {

        var css = {};
        if(row.e0typ == "xx") {
            css.background = "#3c983c";
            css.color = "#fff";
        }
        if(this.state.fkn == "FSK") {
            if(row.e0typ.substr(0,3) !== "fsk") {
                css.display = "none";
            }
        }
        return css;
    }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

  dt_fdat(e) {
    //alert(JSON.stringify(e));
    var dts = format(e, "yyyy-MM-dd");
    this.setState({ fdat: dts });
  }
    dt_tdat(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ tdat: dts });
    }
    dt_bdat(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ bdat: dts });
    }
  oneday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_td.current.updateDt(this.state.fdat);
  }
  addday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_fd.current.updateAdd();
    this.dt_td.current.updateAdd();
  }
  subday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_fd.current.updateSub();
    this.dt_td.current.updateSub();
  }

  change_fkn(e) {
      var self = this;
    //let cdat = this.state.seldate;
    //alert(JSON.stringify(e));
    let fkn = e.target.value;
    this.setState({fkn: fkn}, function () {
        self.syncTb("trsTable");
    });
    //this.setState({tra: [], tsa: [], tta: [] });
  }

  kort_per() {
    var self = this;

      var msg = { info: true, text: "Laddar kort ..."};
      self.setState({ tra: [], msg: msg });

    var prm = {};
    prm.req = "pms.eko.cc_per";
    prm.fdat = this.state.fdat;
    prm.tdat = this.state.tdat;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        if(ret.ok != "000") {
            self.setState({ msg: {} });
            return;
        }
        var sdo = ret.rco;
        self.setState({ dta: sdo.dta, tot: sdo.tot, msg: {} }, function () {
          self.syncTb("kortperTable");
        });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  bank_per() {
    var self = this;

      var msg = { info: true, text: "Laddar bank ..."};
      self.setState({ tra: [], msg: msg });

    var prm = {};
    prm.req = "pms.eko.cc_bank";
    prm.fdat = this.state.fdat;
    prm.tdat = this.state.tdat;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        if(ret.ok != "000") {
            self.setState({ msg: {} });
            return;
        }
        var sdo = ret.rco;
        //alert(JSON.stringify(sdo.dta));
        self.setState({ dta: sdo.dta, tot: sdo.tot, msg: {} }, function () {
          self.syncTb("kortperTable");
        });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }

  tr_edit(row) {
    var self = this;
    var wnds = {};
    wnds.tropen = true;
    wnds.tro = row;
    this.setState({ wnds: wnds });
  }
    syncTb(tb){
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
        tdElements = tbel.getElementsByTagName('td');

        for (let i = 0; i < thElements.length; i++) {
            if(!thElements[i]) continue;
            if(!tdElements[i]) continue;
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
            width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
   tb_sort(typ) {
      var self = this;
      //var rvs = self.state.rvs;
      var tra = self.state.tra;
      var sz = this.state.sz_val;

      tra.sort((a,b) => (a[typ] > b[typ]) ? 1 : ((b[typ] > a[typ]) ? -1 : 0));
      self.setState({ tra: tra, sortid: typ });
   }
  tb_filtr() {
      var self = this;
      var rvs = self.state.rvs;
      var sz = this.state.sz_val;

      if(sz.length < 1) {
        self.setState({ rva: rvs });
          return;
      }
      sz = sz.toUpperCase();
      var rva = rvs.filter(function(row) {
            var brc = false;
            if(row.company.toUpperCase().includes(sz)) brc = true;
            if(row.name.toUpperCase().includes(sz)) brc = true;
            return brc;
      });
      self.setState({rva: rva });
   }
    sel_fkn(sel) {
        //alert(JSON.stringify(fkn));
        if(sel.fkn == "invsrp") {
            this.invs_rp();
        }
        if(sel.fkn == "logi") {
            this.trs_logi();
        }
    }
    invs_rp() {
        var self = this;
        var wnds = {};
        wnds.invsrp = true;
        wnds.fdat = this.state.fdat;
        wnds.tdat = this.state.tdat;
        wnds.bdat = this.state.bdat;
        this.setState({ wnds: wnds });
    }
    wnd_close = () => {
      this.props.ctx.setState({ wnds: {} });
    };

    konto_edit(row) {
      var self = this;
      var wnds = {};
      wnds.krubrv = true;
      wnds.fdat = this.state.fdat;
      wnds.tdat = this.state.tdat;
      wnds.boknr = row.boknr;
      this.setState({ wnds: wnds });
    }

    konto_style() {
      var css = {};
      css.height = "40px";
      css.lineHeight = "40px";
      css.padding = "0px 10px";
      css.fontSize = "12px";
      css.cursor = "pointer";
      return css;
  }

  konto_keydown (e) {
  //e.preventDefault();
    const key = e.key;
    const keyCode = e.keyCode;

    if(keyCode == 13) {
        //this.tb_filtr();
    };
    if(keyCode == 27) {
        this.setState({konto: ""});
    };
}
konto_change (e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({konto: value});
    //setState({[name]: value});
}

  render() {
    return (
      <div className="mx_base">
      { this.props.backdrop ? <div className="mx_backdrop" /> : null }
      <div className="mx_dlg mx_80h flex-col" style={ this.dlg_style() }>
      <div className="mx_h01 flex-row" style={{background: "#1a456b", color: "#fff"}}>
          <div>KORT SUMMERING PERIOD</div>
          <div className="flex"></div>
          <div>UPPDATERA</div>
      </div>

      <div className="mx_content flex px-3">


    <div className="flex-row flex-space-between">
        <div className="flex-row">
        <div className="flex-row">
              <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
              <Dt_Cal dts={ this.state.fdat } rp="1" ref={this.dt_fd} getValue={(e)=> this.dt_fdat(e)} />
              <div className="dt-btn-01" onClick={() => this.oneday() } >1</div>
              <Dt_Cal dts={ this.state.tdat } rp="1" ref={this.dt_td} getValue={(e)=> this.dt_tdat(e)} />
              <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
        </div>
        </div>
        <input className="txt sztxt hide" value={this.state.konto} placeholder="Ange konto..."  style={ this.konto_style() } onChange={(e) => this.konto_change(e)} onKeyDown={(e) => this.konto_keydown(e)} />

        <div className="flex"></div>

        <button className="btn btn-hw-blue w150" onClick={() => this.kort_per() } aria-label="System" >
            Visa
        </button>
    </div>
    <div className="divider_green"></div>

    <div id="kortperTable">
          <table className="table table-bordered table-hover" style={{marginBottom: "0px"}}>
                <thead>
                <tr>
                <th style={ this.th_style("datum") } onClick={() => this.tb_sort("e0datum") }>Period</th>
                <th style={ this.th_style("datum") } onClick={() => this.tb_sort("e0datum") }>Text</th>
                    <th style={ this.th_style("notanr") } onClick={() => this.tb_sort("e0typ") }>Antal</th>
                    <th style={ this.th_style("notanr") } onClick={() => this.tb_sort("e0typ") }>Bank</th>
                    <th style={ this.th_style("notanr") } onClick={() => this.tb_sort("e0typ") }>PMS</th>
                    <th style={ this.th_style("datum") } onClick={() => this.tb_sort("e0datum") }>POS</th>
                    <th style={ this.th_style("e0ptyp") } onClick={() => this.tb_sort("e0ptyp") }>Diff</th>
                </tr>
                </thead>
            </table>
            <div style={ this.tb_style() }>
          <table className="table table-bordered table-hover">
            <tbody>
                { this.state.dta.map((row, key) =>
                    <tr key={key} style={ this.row_style(row) } onDoubleClick={() => this.konto_edit(row) }>
                        <td>{ utils.toLang( row.yymm ) }</td>
                        <td>{ utils.toLang( row.text ) }</td>
                        <td>{ utils.toNum( row.antal ) }</td>
                        <td>{ utils.toPris( row.belopp ) }</td>
                        <td>{ utils.toPris( row.pms ) }</td>
                        <td>{ utils.toPris( row.pos ) }</td>
                        <td>{ utils.toPris( row.diff ) }</td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
        <div className="divider_green"></div>
        <div className="flex-row">
                <div className="txt_14">Bank:{utils.toPris(this.state.tot.trf)}</div>
                <div className="flex"></div>
                <div className="txt_14">System:{utils.toPris(this.state.tot.trs)}</div>
                <div className="flex"></div>
                <div className="txt_14">Diff:{utils.toPris(this.state.tot.diff)}</div>
        </div>

        </div>

        </div>
        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex-row"></div>
            <button className="btn btn-hw-green w250 hide" onClick={(event) => this.kort_per() } >
                TEST
            </button>
            <div className="flex-row"></div>
            <button className="btn btn-hw-green w250 hide" onClick={(event) => this.kort_per() } >
                HÄMTA
            </button>
      </div>

        </div>
      </div>
  );
}
}
export default Kort_Per;

/*

*/